/**
 * Shared constants used across all environments
 */
export const SYNCFUSION_LICENSE_KEY =
  "Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXtecnVRRGdfUkx2WUE=";
